import { render } from "./FeedbackboardPhonemicVowel.vue?vue&type=template&id=39a23098&scoped=true"
import script from "./FeedbackboardPhonemicVowel.vue?vue&type=script&lang=js"
export * from "./FeedbackboardPhonemicVowel.vue?vue&type=script&lang=js"

import "@/css/components/feedbackboard-phonemic-vowel.css?vue&type=style&index=0&id=39a23098&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a23098"]])

export default __exports__